import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.button = {
      width: '48px',
      height: '48px',
      borderRadius: '50%',
      backgroundColor: 'white',
      border: '1px solid #e0e0e0',
      color: '#222222',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'all 0.2s ease',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      '&:hover': {
        backgroundColor: '#f5f5f5',
        borderColor: '#d0d0d0',
      },
      '&:focus': {
        outline: 'none',
        boxShadow: '0 0 0 2px rgba(34, 34, 34, 0.2)',
      },
    };

    this.disabled = {
      opacity: 0.5,
      cursor: 'not-allowed',
      '&:hover': {
        backgroundColor: 'white',
        borderColor: '#e0e0e0',
      },
    };
  })()
);
